import React from 'react';
import type { Agent } from '../../types';
import { cn, getAgentAvatarClass } from '../../utils';

interface TypingIndicatorProps {
  agent?: Agent | null;
  conversationId?: string;
  className?: string;
}

export function TypingIndicator({ agent, className }: TypingIndicatorProps) {
  return (
    <div className={cn('flex animate-fade-in items-center gap-3 px-5 py-3', className)}>
      <div
        className={cn(
          'flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full text-sm font-semibold text-white',
          agent ? getAgentAvatarClass(agent.id) : 'bg-muted',
        )}
      >
        {agent?.avatar || '🤖'}
      </div>

      <div className="rounded-[1.25rem] border border-border bg-card/80 px-4 py-3 shadow-sm shadow-black/5">
        <div className="mb-1 text-sm text-muted-foreground">
          {agent ? `${agent.name} is thinking...` : 'AI is thinking...'}
        </div>
        <div className="flex gap-1">
          <div className="h-2 w-2 animate-bounce rounded-full bg-slate-500" style={{ animationDelay: '0ms' }} />
          <div className="h-2 w-2 animate-bounce rounded-full bg-slate-500" style={{ animationDelay: '150ms' }} />
          <div className="h-2 w-2 animate-bounce rounded-full bg-slate-500" style={{ animationDelay: '300ms' }} />
        </div>
      </div>
    </div>
  );
}

export default TypingIndicator;
